module.exports = __webpack_public_path__ + "static/img/redshow_09@2x.4f240fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/party/redshow_09@2x.png
// module id = UDy+
// module chunks = 0